import React, { useState, useRef, useImperativeHandle, forwardRef } from 'react'
import { Input, Button, Box } from "@chakra-ui/react"

const FileUpload = forwardRef(({ _onChange, ...props }, ref) => {
    const [files, setFiles] = useState(null)
    const inputRef = useRef(null)
  
    const handleFileChange = (e) => {
        if (e.target.files) {
            setFiles(e.target.files.length ? e.target.files : null)
        }
        if (_onChange) {
            _onChange(e)
        }
    }
  
    const handleButtonClick = () => {
        inputRef.current?.click()
    }
  
    const reset = () => {
        if (inputRef.current) {
            inputRef.current.value = ''
        }
        setFiles(null)
    }

    useImperativeHandle(ref, () => ({ reset }))

    const getButtonText = () => {
        if (!files || files.length === 0) {
            return props.multiple ? 'Выберите файлы' : 'Выберите файл'
        }
        return props.multiple 
            ? `Выбрано файлов: ${files.length}`
            : files[0].name.length > 23 ? files[0].name.substring(0, 20) + '…' : files[0].name
    }
  
    return (
        <Box>
            <Input
                type="file"
                ref={inputRef}
                onChange={handleFileChange}
                display='none'
                {...props}
            />
            <Button
                onClick={handleButtonClick}
                variant="outline"
                size={props?.size || 'md'}
            >
                {getButtonText()}
            </Button>
        </Box>
    )
})

export default FileUpload
